import Crud from '../views/TipoAcompanhante/Crud'
import Entity from '../views/TipoAcompanhante/Add'

let routes = {
    path: '/tipo_acompanhante',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/tipo_acompanhante/add',
            name: 'NovoAcompanhante',
            component: Entity
        },
        {
            path: '/tipo_acompanhante/edit/:id?',
            name: 'EditarAcompanhante',
            component: Entity
        },
        {
            path: '/tipo_acompanhante',
            name: 'list-tipo-acompanhante',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Tipos de Acompanhante',
                breadcrumb: [
                    {
                        text: 'Tipos de Acompanhante',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
